import { render, staticRenderFns } from "./CIcon.vue?vue&type=template&id=6666f15e&scoped=true"
import script from "./CIcon.vue?vue&type=script&lang=js"
export * from "./CIcon.vue?vue&type=script&lang=js"
import style0 from "./CIcon.vue?vue&type=style&index=0&id=6666f15e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666f15e",
  null
  
)

export default component.exports